<template>
  <div class="min-h-screen" :class="isDark ? 'bg-gray-900' : 'bg-white'">
    <Hero />
    <ToolsSection />
    <BlogSection />
    <Projects />
    <Skills />
    <Notes />
    <Contact />
  </div>
</template>

<script>
import { useTheme } from '../composables/useTheme'
import Hero from '../components/Hero.vue'
import BlogSection from '../components/BlogSection.vue'
import Projects from '../components/Projects.vue'
import ToolsSection from '../components/ToolsSection.vue'
import Skills from '../components/Skills.vue'
import Notes from '../components/Notes.vue'
import Contact from '../components/Contact.vue'

export default {
  name: 'Home',
  setup() {
    const { isDark } = useTheme()
    return { isDark }
  },
  components: {
    Hero,
    BlogSection,
    Projects,
    ToolsSection,
    Skills,
    Notes,
    Contact
  }
}
</script>
